import { registerFeature } from "lib/features"

export const FEATURE_FLAG_REGIME_NAVIGATOR = registerFeature({
    numericalId: 2.2,
    name: "Regime Navigator",
    id: "navigator",
    description: "Regime navigator feature within a regime.",
    readyForProduction: true,
})
